import { authService } from "@api/auth";
import AuthForm from "@components/auth-form";
import AuthLayout from "@components/auth-layout";
import { Link } from "@ui/elements/link";
import { TextField } from "@ui/form/fields";
import SubmitButton from "@ui/form/submit-button";
import { FormErrors, FormValues } from "@ui/types";
import { useRouter } from "next/router";
import { toast } from "sonner";

export default function ForgotPassword() {
  const router = useRouter();

  const email = Array.isArray(router.query.email) ? router.query.email[0] : router.query.email;

  async function submit(formValues: FormValues) {
    try {
      await authService.forgotPassword(formValues.email);
      router.push("/messages");
    } catch {
      toast.error("Invalid email address");
    }
  }

  function validate(formValues: FormValues): FormErrors {
    const formErrors: FormErrors = {};
    if (!formValues.email) {
      formErrors.email = "Email is required";
    }
    return formErrors;
  }

  return (
    <AuthLayout title="Forgot Password">
      <AuthForm
        title="Recover your password"
        subtitle="Enter your account email and we'll send you a link."
        onSubmit={submit}
        validate={validate}
        initialValues={{ email }}
      >
        <div className="space-y-4">
          <TextField type="email" name="email" label="Email" autoComplete="email" />
        </div>
        <div className="flex flex-col items-center mt-5 space-y-4">
          <SubmitButton size="xl" className="w-full">
            Send reset email
          </SubmitButton>
          <div className="text-sm">
            <Link href="/login" className="hover:text-purple-500 font-medium text-purple-600">
              Back to Login
            </Link>
          </div>
        </div>
      </AuthForm>
    </AuthLayout>
  );
}
